// Send to memory…'s words (brief 49, ADR 0030's amendment of decision 6): the source's name, what
// the sheet says before it sends, and what it says after.

import type { Opened } from '../engine/protocol.ts'

/// An organisation whose memory the person may send to: this host's ('' for its origin), or one
/// the desktop app is signed in to.
export interface Organisation {
  origin: string
  name: string
}

/// What the memory's import answered (the shell's MemoryImportReport).
export interface Imported {
  units: number
  entriesNew: number
  entriesPresent: number
  skippedEmpty: number
}

const plural = (n: number, one: string, many = `${one}s`) => `${n.toLocaleString('en')} ${n === 1 ? one : many}`

/// The source's name in the memory: the session's two documents, as the heading bar names them.
export function sourceName(opened: Opened): string {
  return opened.kind === 'documents' ? `${opened.source.join(', ')} → ${opened.target.join(', ')}` : opened.name
}

/// What goes, said before anything is sent.
export function sendWords(organisation: Organisation, name: string, paired: number, oneSided: number, excluded: number): { to: string; counts: string } {
  const out = excluded ? ` ${plural(excluded, 'excluded row')} ${excluded === 1 ? 'is' : 'are'} left out as marked.` : ''
  return {
    to: `The TMX Export TMX writes goes into ${organisation.name}’s memory as a new source, “${name}”.`,
    counts: `${plural(paired, 'two-sided row')} ${paired === 1 ? 'goes' : 'go'}, and ${plural(oneSided, 'one-sided row')} ${oneSided === 1 ? 'is' : 'are'} left out, since a pair needs text on both sides.${out}`,
  }
}

/// What the memory took.
export function sentWords(organisation: Organisation, name: string, r: Imported): string {
  return `${organisation.name}’s memory has the new source “${name}”: ${plural(r.units, 'unit')}, ${plural(r.entriesNew, 'new pair')} and ${plural(r.entriesPresent, 'pair')} it already held.`
}
